import { calculateDigit, charValue, isRepeatedSequence } from './taxIdChecksum';
import { CPF_LENGTH, sanitizeCpf } from './cpf';

export const CNPJ_LENGTH = 14;

const WEIGHTS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function sanitizeCnpj(value) {
  if (value == null) {
    return '';
  }

  return String(value).replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

export function looksLikeCnpj(value) {
  if (!value) {
    return false;
  }

  if (/[A-Za-z]/.test(value)) {
    return true;
  }

  return sanitizeCpf(value).length > CPF_LENGTH;
}

export function validateCnpj(value) {
  if (!value) {
    return false;
  }

  const normalized = sanitizeCnpj(value);

  if (normalized.length !== CNPJ_LENGTH) {
    return false;
  }

  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(normalized)) {
    return false;
  }

  if (isRepeatedSequence(normalized)) {
    return false;
  }

  const values = normalized.split('').map(charValue);
  const digit1 = calculateDigit(values.slice(0, 12), WEIGHTS_DV1);
  const digit2 = calculateDigit(values.slice(0, 13), WEIGHTS_DV2);

  return digit1 === values[12] && digit2 === values[13];
}

export function formatCnpjDisplay(value) {
  const normalized = sanitizeCnpj(value).slice(0, CNPJ_LENGTH);
  const parts = [
    normalized.slice(0, 2),
    normalized.slice(2, 5),
    normalized.slice(5, 8),
    normalized.slice(8, 12),
    normalized.slice(12, 14),
  ];

  let formatted = parts[0];
  if (parts[1]) formatted += `.${parts[1]}`;
  if (parts[2]) formatted += `.${parts[2]}`;
  if (parts[3]) formatted += `/${parts[3]}`;
  if (parts[4]) formatted += `-${parts[4]}`;

  return formatted;
}
